<script>
export default {
  props: {
    label: { type: String, required: false }, // Input label
    type: { type: String, default: "text" }, // Same as input property
    id: { type: String, required: false }, // Same as input property
    name: { type: String, required: false }, // Same as input property
    disabled: { type: Boolean, default: false }, // Same as input property
    readonly: { type: Boolean, default: false }, // Same as input property
    placeholder: { type: String, required: false }, // Same as input property
    validate: { type: String, required: false }, // Vee-validate rule
    validateAs: { type: String, required: false }, // Vee-validate data-vv-as (for error messages)
    errorText: { type: String, required: false }, // optional error message displayed below the input element
    helpText: { type: String, required: false }, // optional text displayed below the input element
    elementClass: { type: String, required: false }, // optional class applied to the root element
    labelClass: { type: String, required: false }, // optional class applied to the label element
    inputClass: { type: String, required: false } // optional class applied to the input element
  }
};
</script>